"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iSokoSiteHeaders = exports.SokoSiteFormTypes = exports.iSokoSiteFormTypes = void 0;
const t = require("io-ts");
var iSokoSiteFormTypes;
(function (iSokoSiteFormTypes) {
    iSokoSiteFormTypes["WorksiteDiaryForm"] = "WorksiteDiaryForm";
    iSokoSiteFormTypes["TRMeterForm"] = "TRMeterForm";
    iSokoSiteFormTypes["MVRMeterForm"] = "MVRMeterForm";
})(iSokoSiteFormTypes = exports.iSokoSiteFormTypes || (exports.iSokoSiteFormTypes = {}));
// Enum-like validator
exports.SokoSiteFormTypes = t.keyof({
    [iSokoSiteFormTypes.WorksiteDiaryForm]: null,
    [iSokoSiteFormTypes.TRMeterForm]: null,
    [iSokoSiteFormTypes.MVRMeterForm]: null
});
exports.iSokoSiteHeaders = t.intersection([
    t.interface({
        id: t.number,
        diary_uuid: t.string,
        name: t.string,
        form_type: exports.SokoSiteFormTypes,
        entries: t.number,
        waiting_for_signatures: t.number,
        ready: t.number,
    }),
    t.partial({
        site_number: t.union([t.null, t.string]),
    })
]);
//# sourceMappingURL=sokoSite.js.map